import { requester } from "App";
import { createAction, createReducer, createSlice } from "@reduxjs/toolkit";
import { setLocalStorage, getTokenPayload } from "shared/utils/Utils";

export const HistoryReducer = createSlice({
    name: "History",
    initialState: {
        prevUrl: "/",
        currentUrl: "/",
        isLoading: false,
        isBrandLoading: false,
        slideGuide: false,
        isRailActive: false,
        deviceCode: null,
        requestDeviceCode: null,
        activeOutlets: []
    },

    reducers: {
        setHistory: (state, action) => {
            let payload = action.payload;
            return {
                ...state,
                prevUrl: state.currentUrl,
                currentUrl: payload
            };
        },

        setLoading: (state, action) => {
            let payload = action.payload;
            return {
                ...state,
                prevUrl: state.currentUrl,
                isLoading: payload
            };
        },

        setBrandLoading: (state, action) => {
            let payload = action.payload;
            return {
                ...state,
                prevUrl: state.currentUrl,
                isBrandLoading: payload
            };
        },

        setSlideGuide: (state, action) => {
            let payload = action.payload;
            return {
                ...state,
                prevUrl: state.currentUrl,
                slideGuide: payload
            };
        },

        setIsRailActive: (state, action) => {
            const { isRailActive, deviceCode } = action.payload;
            return {
                ...state,
                prevUrl: state.currentUrl,
                isRailActive,
                deviceCode
            };
        },
        setRailStatus: (state, action) => {
            state.isRailActive = action.payload.isRailActive;
            state.deviceCode = action.payload.deviceCode;
            state.requestDeviceCode = action.payload.requestDeviceCode;
        },
        setActiveOutlets: (state, action) => {
            state.activeOutlets = action.payload;
        },
        resetOutletState: (state) => {
            state.activeOutlets = [];
        },
        resetRailState: (state) => {
            state.isRailActive = false;
        },
        // 전체 상태 리셋
        reset(state) {
            return {
                ...state,
                prevUrl: "/",
                currentUrl: "/",
                isLoading: false,
                isRailActive: false,
                deviceCode: "",
                requestDeviceCode: "",
                activeOutlets: [],
            };
        }
    },

    extraReducers: {}
});